
import Vue from "vue";
import { NewPublicPlacesApiFunc, NewWebsitesApiFunc, setAccessToken } from "@/api";
import { Website, PublicPlace } from "@/models";

import WebsitePublicPlaceList from "./components/WebsitePublicPlaceList.vue";
import TheTemplate from "../../TheNoSidebarTemplate.vue";
// import SlideOutToRight from '@/components/BaseSlideOutToRight.vue'

export type DataType = {
  website?: Website;
  publicPlaces: Array<PublicPlace>;
  totalPage: number;
  currentPage: number;
  slideOutToRight: boolean;
};

export default Vue.extend({
  name: "WebsitePublicPlaceListScreen",

  components: {
    TheTemplate,
    WebsitePublicPlaceList,
  },

  data(): DataType {
    return {
      website: undefined,
      publicPlaces: [],
      totalPage: 0,
      currentPage: 0,
      slideOutToRight: false,
    };
  },

  computed: {
    isAdmin(): boolean {
      return this.$auth.role === "admin";
    },

    websitePasscodeText(): string {
      return this.website?.passcode || "-";
    },

    websiteUseTenantIdPassText(): string {
      return this.website?.useTenantIdPass === true ? "必要" : "不要";
    },
  },

  mounted() {
    this.getWebsite();
    this.fetchWebsitePublicPlaces();
  },

  watch: {
    $route(to) {
      if (to.params.updated === "true") {
        this.getWebsite();
        this.fetchWebsitePublicPlaces();
      }
    },
  },

  methods: {
    async getWebsite(): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      const websiteId = this.$router.currentRoute.params.websiteId;
      setAccessToken(this.$auth.accessToken);
      const { data, err } = await NewWebsitesApiFunc().getWebsite(companyId, websiteId);

      if (err != null) {
        this.$handleApiError(err, this.getWebsite);
        return;
      }

      this.website = data;
    },

    async fetchWebsitePublicPlaces(): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      const websiteId = this.$route.params.websiteId;
      const filterString: string = JSON.stringify({});
      setAccessToken(this.$auth.accessToken);
      const { data, err } = await NewPublicPlacesApiFunc().listPublicPlaces(companyId, websiteId, filterString, -1);

      if (err != null)
        return this.$handleApiError(err, () => {
          this.fetchWebsitePublicPlaces();
        });

      this.publicPlaces = data.list;
      this.currentPage = data.currentPage;
      this.totalPage = data.totalPage;
    },

    async updateWebsitePublicPlaces(list: PublicPlace[]): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      this.$setLoading(true);

      list.forEach((e, index) => {
        e.sort = index;
      });

      const websiteId = this.$route.params.websiteId;
      setAccessToken(this.$auth.accessToken);
      const { err } = await NewPublicPlacesApiFunc().updatePublicPlaces(companyId, websiteId, list);

      if (err != null) {
        this.$handleApiError(err, () => {
          this.updateWebsitePublicPlaces(list);
        });
        this.$setLoading(false);
        return;
      }
      this.publicPlaces = list;
      this.$setLoading(false);
      this.$setChecked(true);
    },

    cancel(): void {
      this.slideOutToRight = true;
      this.$router.push({
        name: `company-websites`,
        params: {
          updated: "true",
        },
      });
    },
  },
});
